import {
  DebouncedTextInput,
  ReferenceSelectInput,
  useSaveMutation,
} from "ra-friendsofbabba";

import React from "react";
import { SimpleForm } from "react-admin";

const Form = ({ create, ...props }) => {
  const save = useSaveMutation({ ...props });
  return (
    <SimpleForm {...props} save={save} redirect="list">
      <ReferenceSelectInput
        label="Language"
        source="language_id"
        reference="languages"
        optionText="name"
      />
      <DebouncedTextInput source="code" />
      <DebouncedTextInput source="text" fullWidth multiline />
    </SimpleForm>
  );
};
export default Form;
